// extracted by mini-css-extract-plugin
export default {"tips":"Create_tips__wzlkj","modalContentSty":"Create_modalContentSty__5rEuZ","footerSty":"Create_footerSty__YHxfb","wrapperPadding":"Create_wrapperPadding__IW26z"};